import MenuState from "./menuState";

export default [
  MenuState
]



// WEBPACK FOOTER //
// ./src/store/platform/index.js